import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

interface IToken {
    sub: string;
    email_verified: boolean;
    exp: number;
    email: string;
}

export function decodeToken(): IToken | null {
    try {
        const token = Cookies.get('token') || '';
        if (token) {
            const decodedToken = jwtDecode<IToken>(token);

            return decodedToken;
        } else {
            clearStorages();
            return null;
        }
    } catch (error) {
        clearStorages();
        return null;
    }
}

export function checkIsExpired(decodedToken: IToken): boolean {
    let isExpired = false;

    const currentTime = Math.floor(Date.now() / 1000);

    if (decodedToken.exp && currentTime >= decodedToken.exp) {
        isExpired = true;
        clearStorages();
    }

    return isExpired;
}

export function clearStorages() {
    Cookies.remove('companyId');
    Cookies.remove('employeeId');
    Cookies.remove('session');
    Cookies.remove('userEmail');
    Cookies.remove('token');
    Cookies.remove('loggedCompanyId');
    Cookies.remove('loggedCompany');
    

    localStorage.removeItem('safeGear_authUsername');
    localStorage.removeItem(process.env.STORAGE_FILTER_KEY || '');
}

export default IToken;
